import { Injectable, inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { switchMap, tap } from 'rxjs';
import { STAMP_PROVIDER } from 'src/app/common/tokens';
import { AppConfigQuery } from 'src/app/modules/app-config';
import { ApplicationQuery } from '../application/application.query';
import { StampsStore } from './stamps.store';

@Injectable({ providedIn: 'root' })
export class StampsService {
  private appQuery = inject(ApplicationQuery);
  private apiConfigQuery = inject(AppConfigQuery);
  private logger = inject(NGXLogger);
  private stampsProvider = inject(STAMP_PROVIDER);
  private store = inject(StampsStore);

  constructor() {
    this.appQuery.userLoggedIn$
      .pipe(
        // Update stamps when a user is logged in.
        switchMap(() => this.get())
      )
      .subscribe({
        next: (stamps) => {
          this.logger.debug('Loaded stamps:', stamps);
        },
        error: (error) => {
          this.logger.error('Unable to load stamps.', error);
        },
      });
  }

  /**
   * Gets stamps from the API, stores them in the cache and returns them from this function.
   * @returns An observable array of stamps.
   */
  get() {
    return this.stampsProvider.getStamps().pipe(
      tap((stamps) => {
        this.store.set(stamps);
      })
    );
  }
}
